import * as React from 'react';
import * as styles from './style.css';
import { UIHeading5, Link } from '@cian/ui-kit';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';

interface IAgentsAdvertiseProps {
  fromAgentsPropsLink: string;
  fromAgentsCountsDisplay: string;
  onClick: () => void;
}

export const AgentsAdvertise = ({ fromAgentsPropsLink, fromAgentsCountsDisplay, onClick }: IAgentsAdvertiseProps) => {
  return (
    <div className={styles['agents-advertise']}>
      <UIHeading5 display="inline">
        Застройщик всё распродал, но есть{' '}
        <Link
          href={fromAgentsPropsLink}
          fontWeight="bold"
          fontSize="S"
          target="_blank"
          onClick={onClick}
          data-testid="agents_advertise_link"
        >
          {`${fromAgentsCountsDisplay} от${NO_BREAK_SPACE}агентов и${NO_BREAK_SPACE}собственников`}
        </Link>
      </UIHeading5>
    </div>
  );
};
